<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Departments" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#departmentAdd">Add Department</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in departments" :key="item.id">
                                            <td>{{ item.deptname }}</td>
                                            <td>{{ (item.deptstatus == 1) ? 'Active' : 'De-Active' }}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_dept(item)"><i
                                                            class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_dept(item.id)"><i
                                                            class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->

    <ModalsPart v-if="!['login'].includes($route.name)" @getDeptData="updateData" :edit_dept_row="edit_dept_row" />
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    responseType: 'json'
};
export default {
    name: 'Departments',
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
            departments: [],
            edit_dept_row:[]
        }
    },
    methods: {
        updateData(value) {
            this.departments = value;
        },
        getBasics() {
            var self = this;
            axios.post('getDepartments', config).then(function (response) {
                self.departments = response.data.departments;
                window.scrollTo(0, 0);
            });
        },
        remove_dept(id) {
            var self = this;
            axios.post('removeDept', { dept_id: id }).then(function (response) {
                self.departments = response.data.departments;
                window.scrollTo(0, 0);
            });
        },


    //     remove_dept(id) {
    //     var self = this;
    //     Swal.fire({
    //         title: 'Are you sure?',
    //         text: "This action cannot be undone.",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Yes, delete it!'
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             axios.post('removeDept', { dept_id: id }).then(function (response) {
    //                 self.departments = response.data.departments;
                   
    //                 window.scrollTo(0, 0);

    //                 self.$swal("Sucesfully Deleted");
    //             });
    //         }
    //     });
    // },






        edit_dept(item) {
            var self = this;
            self.edit_dept_row=item;
            $("#departmentAdd").modal("toggle");
            // axios.post('editDept', { dept_id: id }).then(function (response) {
            //     self.$emit('getDeptData', response.data.department);
            // });
        }

    }
}
</script>
